import { useSelector } from 'react-redux';
import { Box, Flex, Grid, Separator } from '@radix-ui/themes';
import ProfilePictureForm from '../forms/ProfilePictureForm';
import GeneralInfo from '../forms/general/GeneralInfo';
import TeacherVerification from './profile/TeacherVerification';
import TeacherHandle from './profile/TeacherHandle';

const TeacherProfile = () => {
    const user = useSelector((state) => state.user.details);

    return (
        <Box width="100%" maxWidth="1080px">
            <Grid columns="4" gapX="8" gapY="4">
                <Box gridColumnStart="1" gridColumnEnd="5" gridRowStart="1">
                    <ProfilePictureForm user={user} size="8" />
                </Box>

                <Flex direction="column" gap="4" align="start" gridColumnStart={{initial: 1, md: 1}} gridColumnEnd={{initial: 5, md: 3}} gridRowStart="2">
                    <GeneralInfo />
                    <Separator size="4" />
                    <TeacherVerification />
                    <Separator size="4" />
                    <TeacherHandle />
                </Flex>

                <Flex direction="column" gap="4" align="start" gridColumnStart={{initial: 1, md: 3}} gridColumnEnd={{initial: 5, md: 5}} gridRowStart={{initial: 3, md: 2}}>
                    {/* Additional teacher-specific content can go here */}
                </Flex>
            </Grid>
        </Box>
    );
};

export default TeacherProfile;
